// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none; /* Remove spinner appearance */
  margin: 0; /* Optional: Adjust margin if needed */
}

.my-swal {
  z-index: 9999999999;
}
`, "",{"version":3,"sources":["webpack://./src/shared/createForms/vendorOnboard.css"],"names":[],"mappings":"AAAA;;EAEE,wBAAwB,EAAE,8BAA8B;EACxD,SAAS,EAAE,sCAAsC;AACnD;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["input[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none; /* Remove spinner appearance */\n  margin: 0; /* Optional: Adjust margin if needed */\n}\n\n.my-swal {\n  z-index: 9999999999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
